import 'babel-polyfill';
// import React from 'react';
// import ReactDOM from 'react-dom';
// https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
import {createRoot} from 'react-dom/client';
import {Route, BrowserRouter, Routes} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css'; // must after the bootstrap!
import AppIndex from './App/AppIndex.js';
import HelpApp from './HelpApp/HelpApp.js';
import NotFound from './App/NotFound.js';
import CONFIG from './global/libs/CONFIG.js';
import {updateConfig} from './global/libs/CONFIG.js';
import ShareQA from './App/ShareQA.js';

/*
  <Route>の修正
    Routesコンポーネントでラップし、propとして表示するコンポーネントを渡すようにする。
    https://zenn.dev/ryuu/scraps/926fed9bb1233e
    https://stackoverflow.com/questions/69832748/error-error-a-route-is-only-ever-to-be-used-as-the-child-of-routes-element

*/

const render_app = () => {
  // ReactDOM.render(
  //     <BrowserRouter>
  //         <div>
  //             {/* <Switch> */}
  //             <Route name="AppIndex" exact path={CONFIG.APP_ROUTE} component={AppIndex} />
  //             <Route exact path="/help" component={HelpApp} />
  //             <Route name="ShareQA" path={CONFIG.QA_SHARE} component={ShareQA} />
  //             <Route component={NotFound} />
  //             {/* </Switch> */}
  //         </div>
  //     </BrowserRouter>,
  //     document.getElementById('wistalk-root'),
  // );
  const container = document.getElementById('wistalk-root');
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <Routes>
        {/* <Switch> */}
        <Route name="AppIndex" exact path={CONFIG.APP_ROUTE} element={<AppIndex />} />
        <Route exact path="/help" element={<HelpApp />} />
        <Route name="ShareQA" path={CONFIG.QA_SHARE} element={<ShareQA />} />
        <Route element={<NotFound />} />
        {/* </Switch> */}
      </Routes>
    </BrowserRouter>
  );
};

updateConfig(render_app);
